import { cardSrc } from './resultParsers';

const CDN = 'https://wver.sprintstaticdata.com/v230/static/front/img/cards';
const WINNER_ICON = 'https://wver.sprintstaticdata.com/v230/static/front/img/winner.png';

const SUITS = [
  { key: '1', label: 'Spade', icon: `${CDN}/spade.png`, king: 'KSS', suffix: 'SS' },
  { key: '2', label: 'Heart', icon: `${CDN}/heart.png`, king: 'KHH', suffix: 'HH' },
  { key: '3', label: 'Club', icon: `${CDN}/club.png`, king: 'KCC', suffix: 'CC' },
  { key: '4', label: 'Diamond', icon: `${CDN}/diamond.png`, king: 'KDD', suffix: 'DD' },
];

function parseSuitCards(cardString) {
  if (!cardString) return { SS: [], HH: [], CC: [], DD: [] };
  const all = String(cardString).split(',').map((c) => c.trim()).filter((c) => c && c !== '1');
  const groups = { SS: [], HH: [], CC: [], DD: [] };
  for (const c of all) {
    if (c.endsWith('SS')) groups.SS.push(c);
    else if (c.endsWith('HH')) groups.HH.push(c);
    else if (c.endsWith('CC')) groups.CC.push(c);
    else if (c.endsWith('DD')) groups.DD.push(c);
  }
  return groups;
}

// Race 20 result: 4 suit rows (icon + dealt non-K cards + suit K when the suit
// has cards). A full row (5) K gets k-image; winner row gets the winner icon. Right panel Winner / Points / Cards from rdesc
// (split '#'). Icons CDN (admin me /assets 404 karti hai).
export default function Race20Result({ detail }) {
  const win = String(detail?.win ?? '');
  const cards = parseSuitCards(detail?.card);
  const parts = String(detail?.rdesc || '').split('#');
  const winner = parts[0] || detail?.winnat || '';
  const points = parts[1] || '';
  const totalCards = parts[2] || '';

  return (
    <div className="row row5">
      <div className="col-12 col-lg-8">
        <div className="race-result-box">
          {SUITS.map((suit) => {
            const isWinner = win === suit.key;
            const suitCards = cards[suit.suffix] || [];
            const nonKing = suitCards.filter((c) => !c.startsWith('K'));

            return (
              <div key={suit.key} className="pr mb-1">
                <span className="result-image icons">
                  <img src={suit.icon} />
                </span>
                {' '}
                {nonKing.map((c, i) => (
                  <span key={i} className="result-image">
                    <img src={cardSrc(c)} />
                  </span>
                ))}
                {' '}
                {/* Reference: the suit's K only when the suit has cards; k-image (K past
                    the WINNER line) only for a full row of 5 — the winner. */}
                {nonKing.length > 0 && (
                  <span className={`result-image${nonKing.length === 5 ? ' k-image' : ''}`}>
                    <img src={cardSrc(suit.king)} />
                  </span>
                )}
                {' '}
                {isWinner && (
                  <div className="casino-result-cards-item">
                    <img src={WINNER_ICON} className="winner-icon" />
                  </div>
                )}
              </div>
            );
          })}
          <div className="video-winner-text">
            {'WINNER'.split('').map((ch, i) => (
              <div key={i}>{ch}</div>
            ))}
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-4">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            <div>{winner || `K ${SUITS.find((s) => s.key === win)?.label || ''}`}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Points</div>
            <div>{points}</div>
          </div>
          <div className="casino-result-desc-item">
            <div>Cards</div>
            <div>{totalCards}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
